import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Waypoint } from '@homeaway/react-unveil';

class LazyBackgroundImage extends Component {
    static propTypes = {
      /** How many pixels from window bounds should this Lazy Loader unveil itself */
      threshold: PropTypes.number,
      /** Image to load when the component is viewed */
      imageUrl: PropTypes.string.isRequired
    };

    static defaultProps = {
      threshold: 100
    }

    state = {
      visible: false
    }

    handleLazyLoad = () => {
      this.setState({ visible: true });
    }

    render() {
      const {
        children,
        imageUrl,
        threshold,
        ...otherProps
      } = this.props;

      return this.state.visible ? (
        <div
          style={{ backgroundImage: `url('${imageUrl}')` }}
          {...otherProps}
        >
          {children}
        </div>
      ) : (
        <Waypoint
          onEnter={this.handleLazyLoad}
          threshold={threshold}
          useWindowAsScrollParent
          {...otherProps}
        >
          {children}
        </Waypoint>
      );
    }
}

export default LazyBackgroundImage;